<template>
<v-card width="300px" class="rounded-card">
    <v-card-title class="orange lighten-1 mb-2 py-2">
        {{recipe.code}} - {{recipe.name}}
    </v-card-title>
    <v-layout>
      <v-flex xs9>
      <v-card-text class="py-1">
          <span>{{$t('Target Group')}}: </span>
          <span class="font-weight-medium">{{$t(recipe.targetGroup)}}</span>
      </v-card-text>
      <v-card-text class="py-1">
        <v-tooltip bottom color="blue-grey">
          <template v-slot:activator="{on}">
            <span v-on="on">{{$t('Use_Count')}}: </span>
            <span v-on="on" class="font-weight-medium">{{recipe.groupsUse.length}}</span>
          </template>
          <span>
            <ul class="no-ident-ul">
              <li v-for="grp in recipe.groupsUse" :key="grp.code">
                {{ grp.code }} - {{ grp.name }}
              </li>
            </ul>
          </span>
        </v-tooltip>
      </v-card-text>
      </v-flex>
      <v-flex xs3>
      <v-btn icon @click.stop="edit()" :ref="recipe.code">
        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-icon color="primary" v-on="on">mdi-square-edit-outline</v-icon>
          </template>
          <span>{{this.$i18n.t('Edit Recipe') + " " + recipe.code}}</span>
        </v-tooltip>
      </v-btn>
      </v-flex>
    </v-layout>
    <!-- <v-card-actions class="py-0">

    </v-card-actions> -->
    <RecipeTable
      v-bind:value="showDialog"
      v-bind:recipeId="recipe.id"
      v-on:close="close"
      v-on:switch-to="$emit('switch-to', $event)"
    />
</v-card>
</template>

<script>
import RecipeTable from "../components/RecipeTable";

export default {
  name: "RecipePanel",
  props: ["recipeId"],
  data()  {
    return {
      showDialog: false,
    }
  },
  computed: {
      recipe() {
        return this.$store.getters.getRecipe(this.recipeId);
      },
  },
  methods: {
    edit() {
      this.showDialog=true;
    },
    close() {
      this.showDialog=false;
    },

  },
  components: {
     "RecipeTable": RecipeTable,
  }

}
</script>

<style>
  .rounded-card {
    border-radius:8px;
  }
  .no-ident-ul {
    padding: 0;
    list-style-position: outside;
    list-style-type: square;
  }
</style>
